import React from 'react';
import styles from './IntelligentDriveData.module.scss';

// 数据项类型定义
export interface IntelligentDriveItem {
  label: string;
  value: number | string;
}

// 组件Props类型
interface IntelligentDriveDataProps {
  /** 智能驾驶数据数组（外部处理好后传入） */
  intelligentDriveDataArr: IntelligentDriveItem[];
}

/**
 * 智能驾驶数据展示组件（极简版）
 * 仅负责渲染外部传入的intelligentDriveDataArr，无内部数据处理逻辑
 */
const IntelligentDriveData: React.FC<IntelligentDriveDataProps> = ({
  intelligentDriveDataArr,
}) => {
  // 无数据时不渲染
  if (!intelligentDriveDataArr?.length) return null;

  return (
    <div className={styles.dataFlexBox}>
      {intelligentDriveDataArr.map((item, index) => {
        const length = intelligentDriveDataArr.length;
        const classNames = [styles.dataBlock];

        // 保留原有的样式判断逻辑
        const needSmallWidth =
          length === 3 ||
          length === 6 ||
          (length === 5 && [2, 3, 4].includes(index));

        const needMb10 =
          (length === 4 && [0, 1].includes(index)) ||
          (length === 5 && [0, 1].includes(index)) ||
          (length === 6 && [0, 1, 2].includes(index));

        if (needSmallWidth) classNames.push(styles.smallWidth);
        if (needMb10) classNames.push(styles.mb10);

        return (
          <div key={index} className={classNames.join(' ')}>
            <div className={styles.adDataRow}>
              <div className={styles.value}>{item.value}</div>
            </div>
            <div className={styles.name}>{item.label}</div>
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(IntelligentDriveData);